import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PlanTabs, { PlanTabKey, planTabs } from './PlanTabs';
import PlanNetBody from './PlanNetBody';
import { Task as ApiTask } from '../../../services/tasksService';

interface PlanViewProps {
  tasks?: any[];
  rawTasks?: ApiTask[];
  inboxLoading?: boolean;
}

// Tabs valid for ?tab= deep-links (from the header search); anything else
// falls back to the calendar overview.
const VALID_TABS = planTabs.map(t => t.key);
const DEFAULT_TAB: PlanTabKey = 'calendar';

const PlanView: React.FC<PlanViewProps> = ({ tasks = [], rawTasks = [], inboxLoading = false }) => {
  // ── Tab sync via URL ─────────────────────────────────────────────────────
  // /plan?tab=<planTabKey> — read it so the header search can deep-link a
  // sub-tab, and reflect user tab changes back to the URL.
  const [params, setParams] = useSearchParams();
  const urlTab = params.get('tab') as PlanTabKey | null;
  const initialTab: PlanTabKey =
    urlTab && VALID_TABS.includes(urlTab) ? urlTab : DEFAULT_TAB;

  const [activeTab, setActiveTab] = useState<PlanTabKey>(initialTab);

  const changeTab = useCallback((key: PlanTabKey) => {
    setActiveTab(key);
    setParams((sp) => {
      const next = new URLSearchParams(sp);
      next.set('tab', key);
      return next;
    }, { replace: true });
  }, [setParams]);

  // React to URL tab changes (back/forward + header-search navigation).
  useEffect(() => {
    if (urlTab && VALID_TABS.includes(urlTab) && urlTab !== activeTab) {
      setActiveTab(urlTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlTab]);

  return (
    <>
      <PlanTabs
        activeTab={activeTab}
        onTabChange={changeTab}
        asideOpen={false}
        onAsideToggle={() => {}}
      />
      <PlanNetBody
        activeTab={activeTab}
        tasks={tasks}
        rawTasks={rawTasks}
        inboxLoading={inboxLoading}
        asideOpen={false}
        onAsideToggle={() => {}}
      />
    </>
  );
};

export default PlanView;
